import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Range } from './styles';
export const RangeSlider = ({ marks: marksProp, ...restProps }) => {
    const hasMarks = !Array.isArray(marksProp);
    const marks = React.useMemo(() => {
        if (!Array.isArray(marksProp)) {
            return marksProp;
        }
        return marksProp.reduce((acc, item) => ({
            ...acc,
            [item]: _jsx("span", {}),
        }), {});
    }, [marksProp]);
    return _jsx(Range, { ...restProps, marks: marks, "$marked": hasMarks });
};
